import { render, staticRenderFns } from "./DetailInvoice.vue?vue&type=template&id=5d487d60&scoped=true"
import script from "./DetailInvoice.vue?vue&type=script&lang=js"
export * from "./DetailInvoice.vue?vue&type=script&lang=js"
import style0 from "./DetailInvoice.vue?vue&type=style&index=0&id=5d487d60&prod&scoped=true&lang=css"
import style1 from "./DetailInvoice.vue?vue&type=style&index=1&id=5d487d60&prod&lang=css"
import style2 from "./DetailInvoice.vue?vue&type=style&index=2&id=5d487d60&prod&lang=css"
import style3 from "./DetailInvoice.vue?vue&type=style&index=3&id=5d487d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d487d60",
  null
  
)

export default component.exports